import { render, staticRenderFns } from "./ViewResults.vue?vue&type=template&id=369002a2&scoped=true&"
import script from "./ViewResults.vue?vue&type=script&lang=js&"
export * from "./ViewResults.vue?vue&type=script&lang=js&"
import style0 from "./ViewResults.vue?vue&type=style&index=0&id=369002a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369002a2",
  null
  
)

export default component.exports